import React, { useState, useCallback } from 'react';
import { Text, Label, Pane, Button, Flex } from '@leverege/ui-elements';
import { Blueprint } from '@leverege/molten/imagine';
import I18N from '@leverege/i18n';
import { addAdditionalTagsToSale } from '../../util/RecovrSales';
import S from './AddAdditionalTags.css';
import DefaultDialog from '../../components/DefaultDialog';
import Loading from '../../components/Loading';
import RecovrKeyListItem from '../../views/salesFlow/components/RecovrKeyListItem';
import TagInfoCard from './TagInfoCard';
import C from './Constants';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovr.sale.addAdditionalTagsToSale');
export default function AddAdditionalTagsDialog(props) {
  const {
    show,
    onClose,
    actions,
    sale,
    location,
    keysWithTags
  } = props;
  const tagBlueprint = Blueprint.getByType('tag');
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(1);
  const [confirm, setConfirm] = useState(false);
  const [showKeyDetails, setShowKeyDetails] = useState(false);
  const [additionalTagData, setAdditionalTagData] = useState({});
  const [warningMessage, setWarningMessage] = useState('');
  const onKeysChange = useCallback(event => {
    if (Array.isArray(event)) {
      const arrayData = event.reduce((acc, curr) => {
        const {
          data,
          value
        } = curr;
        return {
          ...acc,
          [data]: value
        };
      }, {
        ...additionalTagData
      });
      return setAdditionalTagData(arrayData);
    }
    const {
      data,
      value
    } = event;
    if (value?.tag?.data?.location?.id !== sale?.data?.data?.location?.id) {
      setWarningMessage(t('warningMessage'));
    } else {
      setWarningMessage('');
    }
    return setAdditionalTagData({
      ...additionalTagData,
      [data]: value
    });
  }, [additionalTagData]);
  const onNext = async () => {
    setConfirm(true);
  };
  const showExistingKeyDetails = async () => {
    const keyId = `New Key ${count}`;
    setAdditionalTagData({
      ...additionalTagData,
      [keyId]: {
        sell: false,
        tag: undefined,
        tagId: undefined,
        tagSaleStatus: C.TAG_SALE_STATUS.VERIFIED,
        key: {
          id: `New Key ${count}`,
          data: {
            notes: `New Key ${count}`
          }
        },
        targetScreen: 'addAdditionalTagsToSale'
      }
    });
    setCount(count + 1);
    setShowKeyDetails(true);
  };
  const onConfirm = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    await addAdditionalTagsToSale({
      sale,
      locationId: sale?.data?.data?.location?.id,
      additionalTagData: Object.entries(additionalTagData).reduce((prev, [key, keyData]) => {
        if (keyData.sell && keyData.tag?.id) {
          prev[key] = keyData;
        }
        return prev;
      }, {}),
      actions
    });
    setLoading(false);
    onClose();
  };
  const dialogTitle = 'Add Additional Tags to Sale';
  return /*#__PURE__*/_jsxs(DefaultDialog, {
    show: show,
    onClose: onClose,
    className: S.dialog,
    title: dialogTitle,
    titleIcon: t('titleIcon'),
    submitText: confirm ? 'Save' : 'Next',
    onSubmit: confirm ? onConfirm : onNext,
    submitDisabled: !confirm ? Object.keys(additionalTagData) ? !Object.values(additionalTagData).some(keyData => {
      return keyData.sell === true;
    }) || !Object.values(additionalTagData).filter(item => {
      return item.sell === true;
    }).every(item => {
      return item.tagId != null;
    }) : false : false,
    cancelDisabled: loading,
    children: [!confirm && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Label, {
        variant: "inputTitle",
        children: t('existingTagMsg')
      }), /*#__PURE__*/_jsxs(Pane, {
        variant: "dashboardCard",
        className: S.container,
        children: [/*#__PURE__*/_jsx(Pane, {
          layout: "flex:colL",
          variant: "keysDataCardUpper",
          children: /*#__PURE__*/_jsxs(Flex, {
            variant: "rowL",
            align: "center",
            children: [/*#__PURE__*/_jsx("img", {
              width: 80,
              height: 80,
              src: "https://storage.googleapis.com/recovr-ui-assets/recovr-tag.png"
            }), /*#__PURE__*/_jsxs(Flex, {
              variant: "colM",
              children: [/*#__PURE__*/_jsxs(Text, {
                variant: "bodySmallBold",
                children: [Object.keys(keysWithTags).length, " ", t('titleMsg')]
              }), /*#__PURE__*/_jsx(Text, {
                variant: "bodySmall",
                children: t('titleTextSubMsg')
              })]
            })]
          })
        }), Object.keys(keysWithTags).length > 0 && /*#__PURE__*/_jsx(Pane, {
          variant: "dataCard",
          children: Object.entries(keysWithTags).map(([key, value]) => {
            return /*#__PURE__*/_jsxs(Pane, {
              layout: "flex:rowSpaceBetween",
              children: [/*#__PURE__*/_jsxs(Text, {
                variant: "bodySmall",
                children: [value?.key?.data?.notes, ", ", value?.key?.data?.keyId]
              }), /*#__PURE__*/_jsx(Text, {
                variant: "bodySmall",
                children: sale?.data?.data?.keys[key].tagSerialNumber
              })]
            });
          })
        })]
      }), /*#__PURE__*/_jsx(Label, {
        variant: "inputTitle",
        children: t('selectTagsText')
      }), showKeyDetails && /*#__PURE__*/_jsx(Flex, {
        variant: "colM",
        children: Object.entries(additionalTagData).map(([key, keyData]) => /*#__PURE__*/_jsx(RecovrKeyListItem, {
          actions: actions,
          location: location,
          tagBlueprint: tagBlueprint,
          data: keyData.key,
          saleData: keyData,
          onChange: onKeysChange,
          knowTags: true
        }, key))
      }), warningMessage?.length > 0 && /*#__PURE__*/_jsx(Flex, {
        variant: "colL",
        children: /*#__PURE__*/_jsxs(Text, {
          variant: "salesFlowError",
          style: {
            alignItems: 'flex-start'
          },
          children: [" ", /*#__PURE__*/_jsx("b", {
            children: "Warning:"
          }), " ", warningMessage]
        })
      }), /*#__PURE__*/_jsx(Flex, {
        variant: "rowM",
        children: /*#__PURE__*/_jsx(Button, {
          variant: "secondary",
          icon: "fa fa-fw fa-plus",
          onClick: showExistingKeyDetails,
          children: t('addKeyButton')
        })
      })]
    }), confirm && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "bodySmallBold",
          children: t('confirmSaleTitle')
        }), /*#__PURE__*/_jsx(Text, {
          variant: "bodySmall",
          children: t('confirmSaleText')
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: S.divider
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsx(Label, {
          variant: "sectionTitle",
          children: t('vehicleInformation')
        }), /*#__PURE__*/_jsxs(Pane, {
          className: S.container,
          layout: "flex:colL",
          children: [/*#__PURE__*/_jsxs(Flex, {
            variant: "rowM",
            children: [/*#__PURE__*/_jsxs(Flex, {
              variant: "colM",
              className: S.nameValueContainer,
              children: [/*#__PURE__*/_jsx(Text, {
                className: S.name,
                children: t('vin')
              }), /*#__PURE__*/_jsx(Text, {
                className: S.value,
                children: sale?.data?.data?.vehicle?.vin
              })]
            }), /*#__PURE__*/_jsxs(Flex, {
              variant: "colM",
              className: S.nameValueContainer,
              children: [/*#__PURE__*/_jsx(Text, {
                className: S.name,
                children: t('stockNumber')
              }), /*#__PURE__*/_jsx(Text, {
                className: S.value,
                children: sale?.data?.data?.vehicle?.stocknumber
              })]
            })]
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "row",
            children: [/*#__PURE__*/_jsxs(Flex, {
              variant: "colM",
              children: [/*#__PURE__*/_jsx(Text, {
                className: S.name,
                children: t('make')
              }), /*#__PURE__*/_jsx(Text, {
                className: S.value,
                children: sale?.data?.data?.vehicle?.make
              })]
            }), /*#__PURE__*/_jsx(Flex, {
              variant: "colM"
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: S.divider
      }), /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "bodyBold",
          children: t('tagInformationText')
        }), /*#__PURE__*/_jsx(TagInfoCard, {
          keys: keysWithTags,
          sale: sale,
          additionalTagData: additionalTagData
        })]
      })]
    }), /*#__PURE__*/_jsx(Loading, {
      loading: loading
    })]
  });
}